/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud # Usage This API is used in the `https://yrityksille.elisa.fi/` pages. # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request object for the proposal to update.
 */
export interface UpdateProposalRequest { 
    /**
     * Kind of action user has taken(accept or reject)
     */
    action: UpdateProposalRequest.ActionEnum;
    /**
     * Comments provided by user when action is taken.
     */
    comment?: string;
}
export namespace UpdateProposalRequest {
    export type ActionEnum = 'accept' | 'reject';
    export const ActionEnum = {
        accept: 'accept' as ActionEnum,
        reject: 'reject' as ActionEnum
    };
}


